import { FormBuilderService } from '../../../../core/services/form-builder.service';
import {
  IErrorConfigurationFormModel,
  IFormbuilderFieldTypeConfiguration,
} from '../../../../core/models/form-builder-types-configurations.model';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';
import { FormlyFieldConfig } from '@ngx-formly/core';

export const defaultErrorConfigFormModel: IErrorConfigurationFormModel = {
  layout: '',
  errorKey: '',
};

export const errorComponentGetConfiguration = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: defaultErrorConfigFormModel,
      formlyForm: [
        {
          key: 'layout',
          type: EIremboFormlyFieldTypes.customdropdown,
          defaultValue: 'inline',
          props: {
            label: 'Layout',
            placeholder: 'Select layout',
            bindLabel: 'label',
            bindValue: 'value',
            options: [
              {
                value: 'inline',
                label: 'In Line',
              },
              {
                value: 'boxed',
                label: 'Boxed',
              },
            ],
          },
          expressions: {},
        },
        {
          key: 'errorKey',
          type: EIremboFormlyFieldTypes.customdropdown,
          props: {
            label: 'Generic Fetch Fields',
            required: true,
            placeholder:
              'Select a generic fetch field associated to this error',
            bindLabel: 'label',
            bindValue: 'value',
            options: getAllGenericFetchFormFields(formBuilderServiceInstance),
          },
        },
      ],
    },
  };
};

export const getAllGenericFetchFormFields = (
  formBuilderServiceInstance: FormBuilderService
) => {
  const genericFetchFields = formBuilderServiceInstance
    .getAllFormFieldLabelAndDetails(true, true, [
      EIremboFormlyFieldTypes.customcascadingdropdowns,
    ])
    .map(field => {
      return {
        label: field.label,
        value: field.fieldKey,
        type: field.fieldType,
      };
    })
    .filter(
      field => field.type === EIremboFormlyFieldTypes.customgenericdatafetch
    );
  return genericFetchFields;
};

export const errorCompnentFromSettingsFormModel = (
  model: IErrorConfigurationFormModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  if (field.props) {
    field.props['errorKey'] = model.errorKey ?? '';
    field.props['layout'] = model.layout ?? '';
  } else {
    field['props'] = {
      errorKey: model.errorKey ?? '',
      layout: model.layout ?? '',
    };
  }
  return field;
};

export const errorCompnentParseIntoSettingsFormModel = (
  field: FormlyFieldConfig
): IErrorConfigurationFormModel => {
  return {
    layout: field.props && field.props['layout'] ? field.props['layout'] : '',
    errorKey:
      field.props && field.props['errorKey'] ? field.props['errorKey'] : '',
  };
};
